/**
 * @desc Root Epics
 * @module Epics/Root
 */

import { combineEpics } from 'redux-observable';

import * as categoriaEpics from './categoria';
import * as versionEpics from './version';
import * as personalizationEpics from './personalization';
import * as testDriveEpics from './testDrive';
import * as avaluosEpics from './avaluo';
import * as purchaseEpics from './purchase';

const epics = {
  ...categoriaEpics,
  ...versionEpics,
  ...personalizationEpics,
  ...testDriveEpics,
  ...avaluosEpics,
  ...purchaseEpics,
};

export default combineEpics(...Object.values(epics));
